#### Hirer Relationship Changed Events

To use the SEEK API on behalf of a given hirer, you need to have the appropriate [hirer relationships] configured.
Keeping these relationships up to date was difficult, as changes made after your initial integration had to be manually communicated by SEEK.

You might have addressed this problem by asking SEEK’s customer support team for spreadsheets of the current state of relationships, or maybe by periodically querying the [`hiringOrganizations` query] and calculating a diff.

To make this easier, we’ve introduced a new `HirerRelationshipChanged` event type to the SEEK API.
Like existing event types, you can [create a webhook subscription] that will listen for new `HirerRelationshipChanged` events and use them to automatically update your software.

A sample event might look like this:

```json sample-webhook-body
{
  "events": [
    {
      "id": "seekAnzPublicTest:event:events:RJrWs6Kw13TvACTTXG6qZg",
      "type": "HirerRelationshipChanged",

      "createDateTime": "2020-10-20T23:13:58.804Z",

      "hirerId": "seekAnzPublicTest:organization:seek:93WyyF1h"
    }
  ],
  "subscriptionId": "seekAnzPublicTest:webhookSubscription:events:RNzsabxEX56cuRepCD9A8j",
  "url": "https://example.com/webhook",
  "expireDateTime": "2019-09-13T22:16:10.593Z"
}
```

You can then use the `hirerId` contained in the event to get the current state of the relationship from the [`hiringOrganization` query].

For more information, see the [events section] of the hirer relationships documentation.

[hirer relationships]: /auth/hirer-relationships
[`hiringorganization` query]: /schema/query/hiringOrganization
[`hiringorganizations` query]: /schema/query/hiringOrganizations
[create a webhook subscription]: /events/webhooks#creating-a-subscription
[events section]: /auth/hirer-relationships#events
